import React from 'react';

const customModalHeaderPFI = () => (
  <h2>
    <em>Pray for Israel</em> is on its way to your inbox.
  </h2>
);

export default customModalHeaderPFI;
